import { Button } from '@mui/material';
import styles from './CTRInfoPanel.module.css';
import { OpenLinkIcon } from '@components/Questions/CTRQuestion/CTRInfoPanel/OpenLinkIcon';
import { useContext } from 'react';
import { LocalizationContext } from '@context/LocalizationContext';
import { config } from '@branding/config';
import { useAnalytics } from '@hooks/useAnalytics';
import { REFINE_ANALYTICS_EVENTS } from '@/types/RefineAnalyticsEvents';

export const CTRInfoPanel = () => {
	const { CTR } = useContext(LocalizationContext);
	const { trackRefineEvent } = useAnalytics();

	const handleReadMoreClick = () => {
		trackRefineEvent(REFINE_ANALYTICS_EVENTS.CTR_PAMPHLET_OPENED);
		window.open(config.ctrPamphletUrl, '_blank', 'noopener,noreferrer');
	};

	return (
		<div className={styles.panelContainer}>
			<div dangerouslySetInnerHTML={{ __html: CTR.InfoPanelText }} className={styles.textContainer} />
			<Button onClick={handleReadMoreClick} endIcon={<OpenLinkIcon />} variant={'text'} className={styles.button}>
				{CTR.ReadMoreButtonText}
			</Button>
		</div>
	);
};
